import { config } from '../configuration';
import { ERRORS } from '../constants';
import { Configuration } from '../interfaces';

/**
 * Validates that rollout is initialized, and that rollout name argument is provided
 *
 * @param rolloutName {string} - Rollout name
 */
export const validateArgs = (rolloutName: string): void => {
    if (!config.initialized) {
        throw new Error(ERRORS.NOT_INITIALIZED);
    }

    if (!rolloutName) {
        throw new Error(ERRORS.MISSING_ROLLOUT_NAME_ARGUMENT);
    }
};

/**
 * Validates that identifier argument is provided
 *
 * @param userIdentifier - {string | number} - user identifier. Either userId or uGuid
 */
export const validateIdentifier = (userIdentifier: number | string): void => {
    if (!userIdentifier) {
        throw new Error(ERRORS.MISSING_IDENTIFIER_ARGUMENT);
    }
};

/**
 * Throws an error in case of invalid options
 *
 * @param Configuration
 *   - 'appName' [string]: Application name (ex: 'xxx_perseus'). [required]
 *   - 'serviceUrl' [string]: Service env variable. [required]
 *   - 'rollouts' {string[]}: Array of rollouts to fetch in initialization. (optional)
 *   - 'cacheTtl' {number}: cache time to live (ms). Must be greater than 0. Default is 60000ms (1 minute).
 *   - 'fetchTimeout {number}: timeout for fetch from server (ms). Must be greater >= 0. Default is 1000ms.
 *   - 'refreshTimeout {number}: timeout for refreshes from server (ms). Must be >= 0. Default is 0 meaning, no timeout.
 * @param configuration
 */
export const validateConfiguration = (configuration: Configuration): void => {
    const { cacheTtl, fetchTimeout, appName, serviceUrl, refreshTimeout } = configuration;

    if (!serviceUrl) {
        throw new Error(ERRORS.MISSING_SERVICE_URL);
    }

    if (!appName) {
        throw new Error(ERRORS.MISSING_APP_NAME);
    }

    if (cacheTtl !== undefined && cacheTtl <= 0) {
        throw new Error(ERRORS.INVALID_CACHE_TTL_OPTION);
    }

    if (fetchTimeout !== undefined && fetchTimeout < 0) {
        throw new Error(ERRORS.INVALID_FETCH_TIMEOUT_OPTION);
    }

    if (refreshTimeout !== undefined && refreshTimeout < 0) {
        throw new Error(ERRORS.INVALID_REFRESH_TIMEOUT_OPTION);
    }
};
